import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Engineering",
    body: "Every unit leaves our floor batch-tested — arm torque, load rating, sheeting luminance. If it can't survive a monsoon and a loaded truck, it doesn't ship.",
  },
  {
    num: "02",
    title: "Visibility",
    body: "Safety fails at the speed of a glance. We spec retro-reflective grades and contrast systems that read instantly — day, night, fog, rain.",
  },
  {
    num: "03",
    title: "Infrastructure",
    body: "From a single township gate to a 40 km corridor, we plan vehicle movement as a system — barriers, humps, studs and signage working as one.",
  },
  {
    num: "04",
    title: "Compliance",
    body: "MIRC-aligned signage, documented installation reports, and handover checklists your project auditors will actually appreciate.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="relative py-24 lg:py-32 bg-[#0B0F17]" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="font-mono2 text-xs tracking-[0.35em] uppercase text-amber-400 mb-16 flex items-center gap-3"
      >
        <span className="w-8 h-px bg-amber-500 inline-block" /> The Rorix Doctrine
      </motion.p>

      <div className="space-y-2">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start border-t border-zinc-800 py-10 md:py-14 hover:bg-[#0D1220] transition-colors duration-500 px-2 md:px-4"
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <div className="md:col-span-3">
              <span className="font-display text-6xl md:text-7xl font-bold text-stroke-amber group-hover:text-amber-500 group-hover:[-webkit-text-stroke:0px] transition-all duration-500">
                {c.num}
              </span>
            </div>
            <div className="md:col-span-4">
              <h3 className="font-display text-3xl md:text-4xl font-bold uppercase tracking-wide text-white">
                {c.title}
              </h3>
            </div>
            <div className="md:col-span-5">
              <p className="text-base leading-relaxed text-zinc-400 max-w-md">{c.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
